export const GET_CMS_BLOCK_BY_IDENTIFIER_START = 'GET_CMS_BLOCK_BY_IDENTIFIER_START';
export const GET_CMS_BLOCK_BY_IDENTIFIER_SUCCESS = 'GET_CMS_BLOCK_BY_IDENTIFIER_SUCCESS';
export const GET_CMS_BLOCK_BY_IDENTIFIER_FAILED = 'GET_CMS_BLOCK_BY_IDENTIFIER_FAILED';

export const getCmsBlockByIdentifierStart = () => ({
  type: GET_CMS_BLOCK_BY_IDENTIFIER_START
});

export const getCmsBlockByIdentifierSuccess = (data) => ({
  type: GET_CMS_BLOCK_BY_IDENTIFIER_SUCCESS,
  data
});

export const getCmsBlockByIdentifierFailed = (error) => ({
  type: GET_CMS_BLOCK_BY_IDENTIFIER_FAILED,
  error
});
